<template>
  <div class="sidebar-footer-container" :class="{ hideSidebar: collapse }" @click="toggleClick">
    <i class="el-icon-arrow-left sidebar-footer-icon" />
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleClick() {
      this.$emit("toggleClick");
    }
  }
};
</script>

<style lang="scss" scoped>
.sidebar-footer-container {
  position: relative;
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #00b259;
  cursor: pointer;

  .sidebar-footer-icon {
    font-size: 18px;
    vertical-align: middle;
    margin-right: 20px;
    float: right;
    color: #fff;
    line-height: 40px;
  }
}

.hideSidebar {
  padding-left: 0;
  .sidebar-footer-icon {
    transform: rotate(180deg);
  }
}
</style>
